export enum CommLink {
  AEHF = 'AEHF',
  GALILEO = 'Galileo',
  IRIDIUM = 'Iridium',
  STARLINK = 'Starlink',
  WGS = 'WGS'
}
